exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-callout{font-weight:400;margin:0;white-space:pre-wrap;font-size:1rem}.c-callout__container{margin-bottom:1.5rem}", ""]);

// exports
